import { IFRAME_RESIZE_MESSAGE_TYPE } from '@stuller/ops/assets/iframe-resizer-child'

const ALLOWED_ORIGINS = [
  'stuller.com',
  'stullercloud.com',
  'jewelershowcase.com',
  'http://localhost:4200'
]

/**
 * Parent component for iframe resizer scripts
 */
function iframeResizerParent (): void {
  if (typeof window === 'undefined') {
    return
  }

  window.addEventListener('message', (event) => {
    const { origin, data, source } = event

    const isAllowedOrigin = ALLOWED_ORIGINS.some((allowedOrigin) => {
      const originRegex = new RegExp(`(^|\\.)${allowedOrigin.replace('.', '\\.')}$`)

      return originRegex.test(origin)
    })

    if (!isAllowedOrigin) {
      return
    }

    // Find the iframe that fired the event by checking the source against all iframes on the page
    const allIFrames = Array.from(document.querySelectorAll('iframe'))
    const sourceIframe = allIFrames.find((iframe) => iframe.contentWindow === source)

    if (sourceIframe == null) {
      return
    }

    // Set iframe styles and attributes on initial load
    if (sourceIframe.getAttribute('initialized') !== 'true') {
      sourceIframe.style.border = 'none'
      sourceIframe.style.height = '100vh'
      sourceIframe.style.overflow = 'hidden'
      sourceIframe.style.transition = 'height 0.3s ease'
      sourceIframe.style.width = '100%'

      // Remove iframe scrollbar
      sourceIframe.setAttribute('scrolling', 'no')

      // Add initialized attribute so we don't set these props again
      sourceIframe.setAttribute('initialized', 'true')
    }

    const messageType = data?.type as string | undefined
    const newHeight = data?.height as number | undefined

    if (messageType == null || messageType !== IFRAME_RESIZE_MESSAGE_TYPE || newHeight == null) {
      return
    }

    // Only set height if it has changed
    if (newHeight !== parseInt(sourceIframe.style.height)) {
      sourceIframe.style.height = `${newHeight}px`
    }
  })
}

export {
  iframeResizerParent
}
